<template>
  <div>
    <a class="social-button microsoft-button column is-5-fullhd is-5-tablet is-12-mobile" v-if="enableMicrosoft">
      <MicrosoftWhite/><span class="ml-2">Login with Microsoft</span>
    </a>
    <a class="social-button google-button column is-5-fullhd is-5-tablet is-12-mobile" :href="GoogleURL" v-if="enableGoogle">
      <GoogleColor/><span class="ml-2">Login with Google</span>
    </a>
    <a class="social-button clever-button column is-5-fullhd is-5-tablet is-12-mobile" v-if="enableClever">
      <span class="ml-2">Login with Clever</span>
    </a>

    <FormErrors :errors="nonFieldErrors" v-if="nonFieldErrors"/>
    <FormErrors :errors="emailErrors" v-if="emailErrors"/>

  </div>
</template>

<script>
import MicrosoftWhite from './MicrosoftIconWhite'
import GoogleColor from './GoogleIconColor'
import FormErrors from './FormErrors'
import store from '../store'

import {
  setErrorSocialLogin
} from '../mutationTypes'

import {
  OAuthGoogleLoginURL,
  OAUTH_GOOGLE_CLIENT_ID,
  OAUTH_MICROSOFT_CLIENT_ID,
  OAUTH_CLEVER_CLIENT_ID,
} from '../settings'

const addState = (str, state, page) => (str + `&state=${state}_${page}`)

export default {
  name: 'SocialButtons',
  components: {
    MicrosoftWhite,
    GoogleColor,
    FormErrors,
  },
  data () {
    return {
      state: null,
    }
  },
  props: {
    page: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    }
  },
  mounted () {
    // For security reasons, OAuth suggests we pass a query parameter `state`
    // that acts like a CSRF token. We want to generate something on our side
    // that an attacker cannot guess from another domain. So we use the crypto
    // api to store a secret in local storage that we pass in url and then
    // verify when the user is redirected back to this domain.
    const state = crypto.getRandomValues(new Uint32Array(1))[0].toString()
    localStorage.setItem('state', state)
    this.state = state
  },
  beforeDestroy () {
    // Clear social errors when leaving the page via anchor tag
    store.commit(setErrorSocialLogin, {})
  },
  watch: {
    loading: (newVal, _oldVal) => {
      // Clear social errors when submitting form (i.e. loading)
      if (newVal) { store.commit(setErrorSocialLogin, {}) }
    },
  },
  computed: {
    GoogleURL () {
      return addState(OAuthGoogleLoginURL, this.state, this.page)
    },
    enableGoogle () {
      return OAUTH_GOOGLE_CLIENT_ID !== ''
    },
    enableMicrosoft () {
      return OAUTH_MICROSOFT_CLIENT_ID !== ''
    },
    enableClever () {
      return OAUTH_CLEVER_CLIENT_ID !== ''
    },
    emailErrors () {
      return store.state.socialLoginErrors.email
    },
    nonFieldErrors () {
      return store.state.socialLoginErrors.nonFieldErrors
    }
  }
}
</script>



// WEBPACK FOOTER //
// SocialButtons.vue?ee830352